export enum FabricSetupState {
  // Only Prophecy-managed warehouse — prompt to set up own environment
  UnConfigured = 'unconfigured',
  Configured = 'configured'
}
